/**
 * What a platform role is for, in a sentence, for the invite and change-role
 * dialogs. The role's own description wins; most built-in platform roles have
 * none in the database, so these say it for them. Words only — what a role can
 * actually do is its permission set, shown on the Roles screen.
 */
const HINT: Record<string, string> = {
  PLATFORM_ADMIN: 'Everything on the platform, including roles, settings and signing in as other users. Give it to very few people.',
  PLATFORM_OPS: 'Day-to-day operations: companies, cases and lab routing, partners and physicians. No billing approvals.',
  PLATFORM_FINANCE: 'Invoices, payment confirmations, settlements and staff payouts. No clinical or case work.',
  SUPPORT: 'Onboarding, training and sign-in help. Operational status only, never a clinical record.',
  PHYSICIAN: 'Reviews examinations and signs fitness decisions. Only for registered physicians.',
};

export function roleHint(role: { key: string; description?: string | null }): string | null {
  return role.description?.trim() || HINT[role.key] || null;
}
